<template>
	<div  class="main-page">
	  <a-layout id="mainpage">
		  <Header @navbtn-event="handleHeader"  :isShowLeftSiderVal="true"></Header>
		  <div ref="ContontDiv" class="ContontDiv" >
			  <a-layout  class="layout-cont">
				<template v-if="navShow==true">
					<LeftSider todetail-event="toDetailEvent" ></LeftSider>
				</template>
				<a-layout style="padding: 0 24px 24px" class="mainRightCont"> 
					  <template v-if="isFenPing==true">
						  <a-row :gutter="16">
							  <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
								  <DetailContent :isFenPingVal="true" :seltArtItem="seltArtItem"  :deailId="'div1'" ></DetailContent>
							  </a-col>
							  <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
								  <DetailContent  :isFenPingVal="true" :seltArtItem="seltArtItem2"  :deailId="'div2'" ></DetailContent>
							  </a-col>
						  </a-row>
					  </template>
					  <template v-else>
							<template v-if="deailId=='div1'">
								<DetailContent  :isFenPingVal="false" :seltArtItem="seltArtItem" :deailId="'div1'" ></DetailContent>
							</template>
							<template v-else>
								<DetailContent  :isFenPingVal="false" :seltArtItem="seltArtItem2" :deailId="'div2'" ></DetailContent>
							</template>
					  </template>  
					  <a-spin tip="加载中..." :delay="500" :spinning="spinning" />
				</a-layout>
			  </a-layout>
		  </div>
		</a-layout>
	  <img class="main-bg" src="@/assets/img/main/main-bg.png" alt="" />
	</div>
</template>

<script>
import storage from 'store';
import Header from "./modules/header2.vue";
import LeftSider from "./modules/leftDetail.vue";   
import DetailContent from "./modules/detailContent.vue";   
import {findById,findParentPath,modifyNestedArrayById,modifyNestedArrayByKeyName,findByIdNumber,getArtItem,getSizeHieght,quChongArr} from '@/utils/util';
const GListData = [];
export default {
  name: "detailPage",
  components: {
    Header,
	LeftSider, 	  
	DetailContent
  },
  data() {
    return { 
	  collapsed: false,
	  navShow:true,//左侧菜单是否显示
	  
	  spinning:true,//加载
	  isFenPing:false, 
	  srcLink:"",
	  srcLink2:"",
	  id0:1,
	  id1:2,
	  seltArtItem:{id:0,kk_preview_url:""},
	  seltArtItem2:{id:0,kk_preview_url:""},
	  
	  leftHieght:0,
	  deailId:"div1",
	  isReload:true,//需要刷新
    };
  },
  computed: { 
	  seltArtItemVal(){
		  return this.$store.state.article.seltArtItem;
	  },
	  seltArtItem2Val(){
		  return this.$store.state.article.seltArtItem2;
	  },
	  deailIdVal(){
		  return this.$store.state.article.activeDetailContent;
	  },
	  LeftHieghtVal(){
		  return this.$store.state.article.leftHieght;
	  },
	  isFenPingVal(){
		  return this.$store.state.article.isFenPing; 
	  }
  },  
  watch: { 
	  deailIdVal(newVal){
		  this.deailId=newVal;
	  },
	  isFenPingVal(newVal){
		  this.isFenPing=newVal;
	  },
  	  seltArtItemVal(newVal){
  		  var seltArtItem=this.$store.state.article.seltArtItem;
		  console.log("detail-watch-seltArtItemVal:",seltArtItem);
		  if(seltArtItem !=null && seltArtItem['read']!=undefined && seltArtItem['read']==false)
		  {
			  var p={id:seltArtItem['id']};
			  this.$store.dispatch("article/SetMarkRead",p);
		  }
		  if(seltArtItem!=null)
		  {
			this.seltArtItem=seltArtItem;		  
			var divID=this.$store.state.article.activeDetailContent;			  
		  }
		  //console.log("detail-seltArtItemVal1--------------"); 	  
  	  },
  	  seltArtItem2Val(newVal){
  		  var seltArtItem=this.$store.state.article.seltArtItem2;
		  if(seltArtItem !=null && seltArtItem['read']!=undefined && seltArtItem['read']==false)
		  {
			  var p={id:seltArtItem['id']};
			  this.$store.dispatch("article/SetMarkRead",p);
		  }
		  if(seltArtItem!=null){
			  this.seltArtItem2=seltArtItem;
			  var divID=this.$store.state.article.activeDetailContent;
		  }
		  //console.log("detail-seltArtItemVal2--------------"); 		  
  	  },
	  LeftHieghtVal(newVal){
		  this.LeftHieght=newVal;
	  },		
  },
  activated() {
	console.log('detailPage-页面被激活');
	this.initV();
  },
  deactivated() {
	console.log('detailPage-页面被缓存')
	sessionStorage.removeItem('isRefreshed');
	console.log('-----------释放缓存------');
  },
  created() {
	if(this.$route.meta.keepAlive==false)
	{
	  this.initV();
	}
	console.log("detail----created------end");
  },
  mounted() {
	  var _self=this;
	  setTimeout(function(){
		  _self.spinning=false;
	  },1000);
	  
	  var divCont=this.$refs.ContontDiv;
	  var resizeObserver1 = new ResizeObserver(entries => {
	         for (let entry of entries) {
	           var cr = entry.contentRect;
	  		   _self.divHeight=cr.height;
			   _self.$store.commit('article/SetLeftHieght',cr.height);
	           //console.log('ContontDiv: ', cr.height); 
	         }
	  });
	  resizeObserver1.observe(divCont); // 开始观察目标元素的大小变化。 
	   
		window.addEventListener('beforeunload', () => {
		  sessionStorage.setItem('isReloading', 'true');
		});
		window.addEventListener('load', () => {
		  if (sessionStorage.getItem('isReloading')) 
		  {
			console.log('页面刷新');
			//alert('页面刷新');
			sessionStorage.removeItem('isReloading');
			var _self=this;
			this.$store.commit("article/SetSearchKeyWordsTop","");
			
			var menulist=_self.$store.state.article.menuList;
			if(menulist.length>0)
			{
				storage.set("menulist",menulist);
			}
			else
			{
				var v=storage.get("menulist");
				if(v!=null && v.length>0)
				{
					menulist=v;
					//console.log('页面刷新-menulist-v:',menulist);
				}
			}
			if(menulist.length>0)
			{
				_self.reloadV(menulist);
			}
			else{
				this.$store.dispatch("article/GetMenuList").then(res=>{
					menulist=_self.$store.state.article.menuList;						
					//console.log('页面刷新-menulist-d:',menulist);
					_self.reloadV(menulist);
				});
			}		
			
		  }
		});


  }, 
  methods: {
	  initV()
	  {
		  this.isReload=false;
		  this.seltArtItem=this.$store.state.article.seltArtItem;
		  console.log("detail-seltArtItem",this.seltArtItem);
		  // if(this.seltArtItem.article_id!=null && this.seltArtItem.article_id!=undefined)
		  // {
			 //  storage.set("seltArtItem",this.seltArtItem);
		  // }
		  // else{
			 //  if(storage.get("seltArtItem")!=null)
			 //  {
				//   this.seltArtItem=storage.get("seltArtItem");
			 //  }
		  // }
		  //this.seltArtItem3=this.seltArtItem;
		  this.$store.commit("article/set_seltArtItem2",[]);//this.seltArtItem
		  //console.log("detail-created-seltArtItem-----:",this.seltArtItem);	 
		  		  
		  this.$store.commit('article/SetActiveDetailContent',"div1");
		  this.$store.commit('article/set_isFenPing',false);	  
		  this.$store.commit("article/set_seltArtItem",this.seltArtItem);	
		  if(this.seltArtItem!=null)
		  {
			  if(this.seltArtItem['read']!=undefined && this.seltArtItem['read']==false)
			  {
				  var p={id:this.seltArtItem['id']};
				  this.$store.dispatch("article/SetMarkRead",p);
			  }		  
		  }
		  var id=this.$route.query.id;
		  console.log("detail--created-id:",id);
		  //console.log("seltArtItem:", this.seltArtItem);		  
	  },
	fetchData(id) {
		// 示例方法，根据 id 获取数据		
		var srcLink=GListData[id-1]['src'];
		console.log('Fetching data for ID:', id);	
		console.log('Fetching data for ID:', srcLink);			
		
		// 实际的 API 调用等操作
	 },
	  //left给菜单传递事件
     handleDataFromLeftSider(data){ 
		 console.log(data);
	 },
	 //head给菜单传递事件
	 handleHeader(data){
		 this.navShow=data;
	 }, 
	 
	 setActive3(pplist,setDefault=0)
	 {
	 	  var menuListData=this.$store.state.article.menuList;
	 	  menuListData=modifyNestedArrayByKeyName(menuListData,"class3","active3",function(node){
	 			node.class3=""
	 	  });
	 	  if(pplist.length>0)
	 	  {
	 		  var ival=pplist[pplist.length-1];			  
	 		  menuListData=modifyNestedArrayById(menuListData,ival.id,function(node){
	 			node.class3="active3"
	 		  });
	 	  }		  
	 	  this.$store.commit("article/set_menuList",menuListData);		  		  
	 	  this.$store.commit("article/set_seltMenuItem",pplist[pplist.length-1]);
	 	  console.log("header2-setActive3----------------menuListData:",menuListData);
	 	  console.log("header2-setActive3---------------pplist:",pplist[pplist.length-1]);
	 },
	 reloadV(menulist)
	 {
		 var _self=this;
		 this.$store.dispatch("article/getHomeAction").then(res=>{
		    var arr=findById(menulist,res.datas.id);
		    console.log('页面刷新-arr:',arr); 
		    var params={
		 		id:arr.id,//this.$store.state.article.seltMenuItem
		 		page:1,
		 		pageSize:this.$store.state.article.pageSize, 
		 		istype:"curpage"
		    };
		    //var resDataDetail=_self.$store.state.article.resDataDetail;				   
		    this.$store.commit("article/set_defaultMenuItem",{id:arr.id,name:arr.name});
		    var pplist=findParentPath(menulist,arr.id); 
		    _self.$store.commit("article/set_pplist",pplist);
		    _self.setActive3(pplist);
		    setTimeout(function(){
		 	   _self.$router.push({path:'/main'});
		    },500);
		 });
	 },
  },
 //  beforeRouteLeave(to, from, next) {
 //    //this.$refs.scroller.$forceUpdate()	
	// this.$store.commit('article/SetActiveDetailContent',"div1");
	// this.$store.commit('article/set_isFenPing',false);	   
	// console.log("释放...");
 //    next()
 //  },


};
</script>

<style lang="scss" scoped> 
.main-page {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background-color: #f1f3f5;
  .main-bg {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 300px;
    z-index: 0;
  } 
  #mainpage,.layout-cont,.mainRightCont{
	  background: unset;z-index: 1;
  }
}
.ContontDiv{ height:93.75vw!important;}
.mainRightCont{  
	text-align: center;	 overflow:hidden;
}
.ant-layout-has-sider{
	.mainRightCont{padding-left:10px!important;}
}

</style>
